module.exports = __webpack_public_path__ + "img/friend_header_bg.de8324a2.png";